import { PathOptions } from "leaflet";

export const aves_migratorias_areas_de_concentracao = (
  feature: any
): PathOptions => {
  return {
    fillColor: "#97dbf2",
    color: "#97dbf2",
    weight: 0.5,
    fillOpacity: 0.7,
  };
};
